/**
 * 表示名と参照から、本文へ埋めても壊れない表記を組む。
 *
 * 読み取り側は**表示名の終わりを `](` の並びで決める**（{@link tokenizeMentions}）。名前は
 * 呼び出し側で自由に付け替えられるので `売上[実績](見込)` のような名前も入りうる。そのまま
 * 埋めるとそこで名前が切られ、続きが参照として読めず、**メンション全体が素の文字列になって
 * 対象から落ちる**（記録 53）。候補から選んだのに対象へ並ばないので、原因が名前にあると
 * 気付けない。だから `[` `]` を全角へ寄せる。落とさず寄せるのは、括弧を消すと語の切れ目が
 * 読めなくなる名前があるため。
 *
 * **名前は表示のためのもので、参照が正本である。** だから安全化しても失うものが無い。
 *
 * 呼ぶのは**本文へ名前を新しく埋める側**である。すでに本文に在るメンションを埋め直すときは
 * {@link serializeMentions} を使う。読み取れた名前を通すと全角へ変わってしまう。
 */
export function formatMention(name: string, ref: string): string {
    return `@[${name.replace(/\]/g, "］").replace(/\[/g, "［")}](${ref})`;
}
